import styled from "styled-components";
import { FiTruck } from "react-icons/fi";
import { MdOutlineSecurity } from "react-icons/md";
import { GiReceiveMoney } from "react-icons/gi";
import { RiSecurePaymentFill } from "react-icons/ri";

const Service = () => {
  return (
    <Wrapper>
      <div className="Service-container">
        <div className="Service1">
        <FiTruck />
          <p >SuperFast and On Time Delivery.</p>
        </div>
        <div>
          <div className="Service2">
          <MdOutlineSecurity  />
            <p>Non contact Shipping</p>
          </div>
          <div  className="Service2">
          <GiReceiveMoney />
            <p>Money Back Guranteed</p>
          </div>
        </div>
        <div className="Service1">
        <RiSecurePaymentFill />
          <p >Super Secure payment system</p>
        </div>
        

      </div>

    </Wrapper>
  )
}


const Wrapper=styled.section`
  padding:5rem;  
  
  .Service-container{
    display:grid;
    grid-template-columns:repeat(3,1fr);
    gap:2rem;
    padding:2rem;    
    }
  
  .Service1,  .Service2{
    display:flex;
    border-radius:20px;
    box-shadow:2px 2px 2px 2px  #858b83;   
    justify-content:center;
    align-items:center;
    text-align:center;   
    background-color: #e8f3ed;
    gap: 1rem; 
    }
    
  .Service1{
    flex-direction: column;     
    width:auto;
    height:auto;      
    }
            
  .Service2{
    margin:2rem;
    padding:3rem 1rem;        
    }

svg{
font-size: 6rem}
    
  


@media (max-width: ${({ theme }) => theme.media.mobile}){
  gap:0;
  padding:0; 
  font-size: 1.5rem;

  .Service-container{
    gap:1rem;
    padding:1rem;    
    }

     
  .Service1{
    flex-direction: column;     
    padding:0.5rem;    
    }
            
  .Service2{
    padding:0.5rem;
    gap: 0;
    flex-direction: column;    
    }

svg{
font-size: 3rem}
 
  
   
`;
export default Service
